export const checkIsRichTextEmpty = (value) => {
  if (!value) {
    return true;
  }

  const isEmpty =
    value.content?.length === 1 &&
    value.content[0].type === 'paragraph' &&
    !value.content[0].content;

  return isEmpty;
};
